import React from "react";
import "../../assets/css/purchase_complete.scss";
import logoGeulpic from "../../assets/images/pocket_peace/geulpic_logo.png";

const GeulpicPurchaseComplete = ({ onConfirm }) => {
  return (
    <div className="purchase-complete-page">
      <div className="purchase-complete-container">
        <div className="purchase-logo">
          <img src={logoGeulpic} alt="글픽" />
        </div>

        <div className="purchase-content">
          <h2 className="purchase-title">구매 완료</h2>
          <p className="purchase-description">
            등록된 배송지로 글픽이 발송됩니다.
            <br />
            문의 사항은 아래 고객센터로 연락주시기 바랍니다.
            <br />
            감사합니다.
          </p>

          <div className="customer-service">
            <h3 className="cs-title">대표 고객센터</h3>
            <div className="cs-number">1833-3503</div>
          </div>

          <button className="confirm-button" onClick={onConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeulpicPurchaseComplete;
